<template>
  <base-widget title="Notes">
    <notes
      :notes="notes"
      :loading="notesLoading"
      @add-note="addNote"
    />
  </base-widget>
</template>
<script>
import Notes from '@/components/Widgets/ClientInformation/Notes';

export default {

  name: 'ClientNoteContainer',
  components: {
    Notes,
  },
  data() {
    return {};
  },
  computed: {
    customer() {
      return this.$store.state.customers.item;
    },
    notesLoading() {
      return this.$store.state.customers.notesLoading;
    },
    notes() {
      return this.$store.state.customers.notes.slice(0).sort((n1, n2) => this.$moment(n1.date).unix() < this.$moment(n2.date).unix()).reverse();
    },
  },
  watch: {
    customer(newval) {
      if (!newval) return;
      this.$store.dispatch('customers/fetchNotes', this.customer.pk);
    },
  },
  methods: {
    addNote(note) {
      if (!this.customer) {
        console.error('Could not send note with an undefined customer!');
      }
      const payload = {
        text: note,
        customer: this.customer.pk,
        author: this.$store.state.account.user.profile.pk,
      };
      this.$store.dispatch('customers/addNote', payload);
    },
  },
};
</script>
<style lang="css" scoped>
</style>
